<template>
  <el-select
    :disabled = "disabled"
    filterable
    remote
    value-key="id"
    v-model="merchant"
    :remote-method="loadMerchantList"
    placeholder="输入商家名字或编号搜索"
    @change="onChange"
    clearable
    :style="css">
    <el-option v-for="item in merchantList"
      :key="item.id"
      :label="item.name + '(' + item.code + ')'"
      :value="item" />
  </el-select>
</template>

<script>
export default {
  name: "MerchantSearch",

  props: ["id", "css", 'value', 'disabled'],

  data() {
    return {
      merchant: null,
      merchantList: []
    };
  },

  watch: {
    value() {
      this.loadValue(this.value);
    },

    id : function() {
      this.loadValue(this.id);
    }
  },

  methods: {
    loadValue( _id ) {
      var _this = this;
      if ( !_id || _id == "" ) {
        this.merchant = "";
        return;
      }

      sdk.TicketMerchantApi().findById({
        id : _id
      }).then(res => {
        _this.merchantList = [];
        _this.merchantList.push(res);
        _this.merchant = res;
      });
    },

    setValue(_val) {
      this.merchant = _val;
    },

    // http://s.itaojin.cn/merchant/manage/getMerchantUserByNameOrCode
    loadMerchantList( _query ) {
      var _this = this;
      sdk.TicketMerchantApi().search({
        key: _query
      }).then(res => {
        if(!!res) {
          _this.merchantList = res;
        }
      });
    },

    onChange(e) {
      this.$emit('input', e.id);

      this.$emit("change", Object.assign({'_type' : 'merchant', '_id' : this.id}, e));
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ticket/MerchantSearch.vue